<template>
  <b-card>
    <b-row>
      <b-col>
        <h3 tabindex="0">Visualizar Conferência</h3>
      </b-col>
    </b-row>
    <b-form>
      <b-row>
        <b-col sm="12">
          <b-form-group label="Nome da Conferência: *">
            <b-form-input id="nome" v-model.trim="conferencia.nome" required disabled/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-form-group label="Sigla:">
            <b-form-input id="sigla" v-model.trim="conferencia.sigla" disabled></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Status: *">
            <b-form-radio-group id="status" v-model="conferencia.status" :options="status" required disabled/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2">
          <b-button block @click="navigate('/conferencias')">
            <i class="fa fa-arrow-left"/>&nbsp;&nbsp;Voltar
          </b-button>
        </b-col>
        <b-col sm="6"/>
        <b-col sm="2">
          <b-button block @click="remover()" variant="danger">
            <i class="fa fa-times"/>&nbsp;&nbsp;Excluir
          </b-button>&nbsp;&nbsp;
        </b-col>
        <b-col sm="2">
          <b-button block @click="navigate('/conferencias/cadastrar/' + conferencia.id)" variant="primary">
            <i class="fa fa-floppy-o"/>&nbsp;&nbsp;Editar
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import Vue from 'vue'

export default {
  data () {
    return {
      conferencia: {
        id: parseInt(this.$route.params.idConferencia),
        nome: null,
        sigla: null,
        status: null
      },
      status: [
        {value: true, text: 'Ativo'},
        {value: false, text: 'Inativo'}
      ]
    }
  },
  mounted () {
    this.carregar()
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    carregar () {
      if (this.conferencia.id > 0) {
        Vue.http.get('api/conferencia/index/' + this.conferencia.id).then(response => {
          if (response.body.success) {
            this.conferencia = response.body.data
          }
        })
      }
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    remover (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja excluir este registro?', {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/conferencia/remover/' + this.conferencia.id).then(response => {
            if (response.body.success) {
              this.$store.commit('setMensagemConferencia', 'Conferência removida com sucesso!')
              this.navigate('/conferencias')
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Visualizar.vue